import axios from 'axios';
import { ElMessage, ElNotification } from 'element-plus'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'

const host = '/api';//本地代理
// const host = 'https://test-api.mendaocar.com';//测试
// const host='https://api.mendaocar.com';//正式

// 创建axios实例
const service = axios.create({
    // axios中请求配置有baseURL选项，表示请求URL公共部分
    // baseURL: host,
    baseURL: process.env.VUE_APP_BASE_API,
    // 超时
    timeout: 10000
})

service.interceptors.request.use(config => {
    return config;
})

service.interceptors.response.use(res => {
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200;
    // 获取错误信息
    const msg = res.data.msg
    if (code === 401) {
    } else if (code === 500) {
        ElMessage({
            message: msg,
            type: 'error'
        })
        return Promise.reject(new Error(msg))
    } else if (code !== 200) {
        ElNotification.error({
            title: msg
        })
        return Promise.reject('error')
    } else {
        return res.data
    }
},
    err => {
        let {
            message
        } = err;
        if (message == "Network Error") {
            message = "后端接口连接异常";
        } else if (message.includes("timeout")) {
            message = "系统接口请求超时";
        } else if (message.includes("Request failed with status code")) {
            message = "系统接口" + message.substr(message.length - 3) + "异常";
        }
        ElMessage({
            message: message,
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(err)
    })

export default service